import React, { FC } from 'react';
import { Button } from 'primereact/button';

interface Props {
  textButtonSuccess: string;
  onClickSuccessButton?: () => void;
  type?: 'button' | 'submit' | 'reset';
  onClickBackButton?: () => void;
}

const ActionButtons: FC<Props> = ({
  textButtonSuccess,
  onClickSuccessButton,
  type,
  onClickBackButton,
}) => (
  <>
    <Button
      label={textButtonSuccess}
      onClick={onClickSuccessButton}
      type={type}
      className="p-button-success"
    />
    <Button
      type="button"
      onClick={onClickBackButton}
      className="p-button-link"
    >
      Вернуться назад
    </Button>
  </>
);

export default ActionButtons;
